import { isXylemSSO } from '@/config';
import { InvalidCredentialsError, ServerError, UserAttributeError } from '../errors';
function isValidError(error) {
    return error
        && typeof error === 'object'
        && (error.message || error.error);
}
function isDpError(error) {
    return error
        && typeof error === 'object'
        && !!error.dpError;
}
function isHelloError(error) {
    return error
        && typeof error === 'object'
        && !!error.error;
}
function handleHelloError(error) {
    const { error: { code } } = error;
    if (code !== 'cancelled') {
        throw new ServerError(error);
    }
    const provider = isXylemSSO() ? 'xylem' : 'google';
    throw new InvalidCredentialsError(provider);
}
function isAwsError(error) {
    return error
        && typeof error === 'object'
        && !!error.code;
}
function handlerAwsError(error, hints) {
    if (!isAwsError(error))
        throw new ServerError(error);
    const { code, message } = error;
    switch (code) {
        case 'UsernameExistsException': {
            throw new UserAttributeError(UserAttributeError.ATTRIBUTES.EMAIL, UserAttributeError.FAILURES.TAKEN);
        }
        case 'UserNotConfirmedException': {
            throw new UserAttributeError(UserAttributeError.ATTRIBUTES.EMAIL, UserAttributeError.FAILURES.UNCONFIRMED);
        }
        case 'ExpiredCodeException': {
            throw new UserAttributeError(UserAttributeError.ATTRIBUTES.LINK, UserAttributeError.FAILURES.EXPIRED);
        }
        case 'CodeMismatchException': {
            throw new UserAttributeError(UserAttributeError.ATTRIBUTES.LINK, UserAttributeError.FAILURES.INCORRECT);
        }
        case 'InvalidParameterException': {
            let attribute;
            if (message.includes('given_name'))
                attribute = UserAttributeError.ATTRIBUTES.FIRST_NAME;
            if (message.includes('family_name'))
                attribute = UserAttributeError.ATTRIBUTES.LAST_NAME;
            if (message.includes('email'))
                attribute = UserAttributeError.ATTRIBUTES.EMAIL;
            let failure = UserAttributeError.FAILURES.INVALID;
            if (message.includes('must not be null'))
                failure = UserAttributeError.FAILURES.REQUIRED;
            throw new UserAttributeError(attribute, failure);
        }
        case 'UserLambdaValidationException': {
            const { provider } = hints || { provider: 'unknown' };
            throw new InvalidCredentialsError(provider);
        }
        case 'NotAuthorizedException': {
            if (message.includes('disabled')) {
                throw new InvalidCredentialsError('disabled');
            }
            throw new InvalidCredentialsError();
        }
        default: {
            throw new ServerError(error);
        }
    }
}
export default function throwClientError(error, hints) {
    if (!isValidError(error)) {
        throw new ServerError(error);
    }
    if (isDpError(error)) {
        throw error; // re-throw known exceptions.
    }
    if (isHelloError(error)) {
        return handleHelloError(error);
    }
    return handlerAwsError(error, hints);
}
